import React from 'react'
import { ToastContainer, toast } from 'react-toastify'

const ToastContent = ({ icon, iconClass, textClass, borderColor, bgColor, message, action }) => (
  <div style={{ width: '100%', padding: 12, border: `1px solid ${borderColor}`, borderRadius: 6, background: bgColor }}>
    <div className="dome-d-flex dome-align-center dome-justify-between">
      <div className="dome-d-flex dome-align-center dome-gap6">
        <i className={`${icon} ${iconClass}`} />
        <span className={`dome-p2 ${textClass}`}>{message}</span>
      </div>
      {action && (
        <div onClick={action.onClick} className="dome-d-flex dome-align-center dome-gap6 dome-cursor-pointer">
          <span className="dome-p2 dome-text-w500 dome-color-darkest-grey">{action.label}</span>
          <i className="fa-light fa-arrow-right-long fa-xs dome-color-darkest-grey"></i>
        </div>
      )}
    </div>
  </div>
)

export const AppToastContainer = (props) => (
  <ToastContainer
    position="bottom-right"
    autoClose={2000}
    closeButton={false}
    hideProgressBar={true}
    toastStyle={{ background: 'transparent', boxShadow: 'none', margin: 0, padding: 0 }}
    {...props}
  />
)

export const showErrorToast = ({ message, props }) =>
  toast(
    <ToastContent
      icon="fa-sharp fa-solid fa-circle-exclamation"
      iconClass="dome-color-red-alert"
      textClass="dome-color-red-alert"
      borderColor="var(--red, #D7272D)"
      bgColor="#FBE9EA"
      message={message}
      {...props}
    />
  )

export const showSuccessToast = ({ message, props }) =>
  toast(
    <ToastContent
      icon="fa-sharp fa-solid fa-circle-check"
      iconClass="dome-color-go-green"
      textClass="dome-color-go-green"
      borderColor="var(--green)"
      bgColor="#EAF5EA"
      message={message}
      {...props}
    />
  )

export const showDeleteToast = ({ message, onUndo, props } = {}) =>
  toast(
    <ToastContent
      icon="fa-sharp fa-solid fa-circle-check"
      iconClass="dome-color-red-alert"
      textClass="dome-color-red-alert"
      borderColor="var(--red, #D7272D)"
      bgColor="#FBE9EA"
      message={message}
      action={{ label: 'undo', onClick: onUndo }}
      {...props}
    />
  )
